import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieComponent } from './cookie.component';
import { MotesCookieService } from './cookie.service';

@NgModule({
    declarations: [CookieComponent],
    imports: [
        CommonModule
    ],
    exports: [CookieComponent],
    providers: [MotesCookieService]
})
export class CookieModule { }
